export default {
  accessTokenStorageKey: 'USER_ACCESS_TOKEN',
  currentProjectStorageKey: 'CURRENT_PROJECT',
};
